import React, { useEffect, useState } from "react";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import "./answercontrol.css";

export default function InternProfile() {
  const [config, setConfig] = useState(null);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");


  const [interns, setInterns] = useState([]);
  const [selectedIntern, setSelectedIntern] = useState("");
  const [internProfile, setInternProfile] = useState(null);
  const [submittedAnswers, setSubmittedAnswers] = useState([]);
  const [assignedQuestions, setAssignedQuestions] = useState([]);



  // ---------------- LOAD CONFIG ----------------
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error(err));
  }, []);

  // ---------------- FETCH BATCHES ----------------
  useEffect(() => { 
    if (!config) return;

    const fetchBatches = async () => {
      const res = await fetch(`${config.BASE_URL}${config.GET_BATCHES}`);
      const data = await res.json();
      if (data.success) {
        setBatches(data.batches);
      }
    };

    fetchBatches();
  }, [config]);

  // ---------------- FETCH SLOTS ----------------
  useEffect(() => {
    if (!selectedBatch || !config) return;

    const batchName = batches.find(
      b => String(b.batch_id) === String(selectedBatch)
    )?.batch_name;

    if (!batchName) return;

    const fetchSlots = async () => {
      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_SLOTS_BY_BATCH}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ batch_name: batchName }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setSlots(data.slots);
      } else {
        setSlots([]);
      }

      setSelectedSlot("");
      setInterns([]);
      setSelectedIntern("");
    };

    fetchSlots();
  }, [selectedBatch, batches, config]);

  // ---------------- FETCH INTERNS ----------------
  useEffect(() => {
    if (!selectedSlot || !config) return;

    const batchName = batches.find(
      b => String(b.batch_id) === String(selectedBatch)
    )?.batch_name;

    const fetchInterns = async () => {
      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_INTERNS_BY_BATCH}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            batch_name: batchName,
            slot: selectedSlot,
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setInterns(data.interns);
      } else {
        setInterns([]);
      }

      setSelectedIntern("");
    };

    fetchInterns();
  }, [selectedSlot, selectedBatch, batches, config]);


useEffect(() => {
  if (!selectedIntern || !config) return;

  const fetchDetails = async () => {
    const res = await fetch(
      `${config.BASE_URL}${config.FETCH_INTERN_DETAILS}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          intern_id: selectedIntern,
          batch_id: selectedBatch,   
          slot: selectedSlot 
        }),
      }
    );

    const data = await res.json();

    if (data.success) {
      setInternProfile(data.intern_profile);
      setSubmittedAnswers(data.submitted_answers);
       setAssignedQuestions(data.assigned_questions);
    } else {
      setInternProfile(null);
      setSubmittedAnswers([]);
    }
  };

  fetchDetails();
}, [selectedIntern, selectedBatch, selectedSlot, config, batches]);


const handleDownloadCertificate = async (intern_id) => {
  try {
    
    const detailsResponse = await fetch(
      `${config.BASE_URL}${config.GET_CERTIFICATE_DETAILS}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ intern_id }),
      }
    );

    const detailsData = await detailsResponse.json();

    if (!detailsData.success) {
      alert("Unable to fetch intern details");
      return;
    }

    const intern = detailsData.data;

    // Fetch template file name
    const templateResponse = await fetch(
      `${config.BASE_URL}${config.GENERATE_PDF}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      }
    );

    const templateData = await templateResponse.json();

    if (!templateData.success) {
      alert("Error fetching template");
      return;
    }

    const templateUrl = `/Templates/${templateData.fileName}`;

    // Load template PDF
    const templateBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(templateBytes);

    const page = pdfDoc.getPage(0);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
// Colors
const blue =  rgb(0.121, 0.219, 0.549);    
const green = rgb(0, 0.55, 0);        
const black = rgb(0, 0, 0);           
const white = rgb(1, 1, 1);           


const reverseDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

const startDate = reverseDate(intern.internship_start_date);
const endDate   = reverseDate(intern.internship_end_date);

// Prefix + UPPERCASE name
const prefix = "Mr/Ms. ";
const displayName = `${prefix}${intern.name.toUpperCase()}`;
const domainUpper = intern.domain.toUpperCase();

// ---------------------------
// AUTO SIZE FUNCTION
// ---------------------------
const autoSizeCenter = (text, maxSize, minSize, maxWidth) => {
  let size = maxSize;
  let width = font.widthOfTextAtSize(text, size);

  while (width > maxWidth && size > minSize) {
    size -= 1;
    width = font.widthOfTextAtSize(text, size);
  }

  const x = (page.getWidth() - width) / 2;
  return { size, x };
};

// Max printable width:
const printableWidth = page.getWidth() - 80; 

// ---------------------------
// AUTO-ADJUST NAME
// ---------------------------
const nameFit = autoSizeCenter(displayName, 30, 14, printableWidth);

page.drawText(displayName, {
  x: nameFit.x,
  y: 510,
  size: nameFit.size,
  font,
  color: blue,
});

// ---------------------------
// AUTO-ADJUST DOMAIN
// ---------------------------
const domainFit = autoSizeCenter(domainUpper, 30, 14, printableWidth);

page.drawText(domainUpper, {
  x: domainFit.x,
  y: 440,
  size: domainFit.size,
  font,
  color: green,
});

// ---------------------------
// DATES (fixed size & positions)
// ---------------------------
page.drawText(startDate, {
  x: 180,
  y: 358,
  size: 17,
  font,
  color: black,
});

page.drawText(endDate, {
  x: 406,
  y: 358,
  size: 17,
  font,
  color: black,
});

// ---------------------------
// INTERN ID
// ---------------------------
page.drawText(intern.intern_id, {
  x: 66,
  y: 120,
  size: 17,
  font,
  color: white,
});


    
    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${intern.name}_Certificate.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Certificate generation failed:", error);
    alert("Certificate download failed");
  }
};



const mergedData = assignedQuestions.map((q) => {
  const submitted = submittedAnswers.find(
    (a) => String(a.assignment_id) === String(q.question_id)
  );

  return {
    assignment_id: q.question_id,
    question: submitted?.question || q.question_name || "N/A",
    total_marks: Number(q.total_marks) || 0,
    marks_secured: submitted ? Number(submitted.marks_secured) || 0 : 0,

    // 3-state logic
    status: !submitted
      ? "not_submitted"
      : Number(submitted.answer_status) === 1
      ? "corrected"
      : "pending",

    remark: submitted?.remark || "-"
  };
});

const totalAssignments = mergedData.length;

const passedAssignments = mergedData.filter(
  (a) =>
    a.status === "corrected" &&
    a.marks_secured >= a.total_marks * 0.5
).length;

const overallResult =
  totalAssignments > 0 &&
  passedAssignments >= totalAssignments * 0.5
    ? "Pass"
    : "Fail";



  return (
    <div className="intern-answers-container">
      <h2>Intern Profile</h2>

      {/* Batch */}
      <div className="dropdown-group">
        <label>Batch:</label>
        <select
          value={selectedBatch}
          onChange={e => setSelectedBatch(e.target.value)}
        >
          <option value="">Select Batch</option>
          {batches.map(b => (
            <option key={b.batch_id} value={b.batch_id}>
              {b.batch_name}
            </option>
          ))}
        </select>
      </div>

      {/* Slot */}
      {slots.length > 0 && (
        <div className="dropdown-group">
          <label>Slot:</label>
          <select
            value={selectedSlot}
            onChange={e => setSelectedSlot(e.target.value)}
          >
            <option value="">Select Slot</option>
            {slots.map(s => (
              <option key={s.slot_no} value={s.slot_no}>
                {s.slot_no}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Intern */}
      {interns.length > 0 && (
        <div className="dropdown-group">
          <label>Intern:</label>
          <select
            value={selectedIntern}
            onChange={e => setSelectedIntern(e.target.value)}
          >
            <option value="">Select Intern</option>
            {interns.map(i => (
              <option key={i.intern_id} value={i.intern_id}>
                {i.name} ({i.intern_id})
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Intern Profile Display */}
{internProfile && (
  <div className="profile-card">
    <div className="profile-content">
      {/* Left: Details */}
      <div className="profile-details">
        <h3>{internProfile.name}</h3>
        <p><strong>Email:</strong> {internProfile.email}</p>
        <p><strong>Phone:</strong> {internProfile.phone}</p>
        <p>
        <strong>Aadhar:</strong>{" "}
        {internProfile.application_id && internProfile.aadhar_front && internProfile.aadhar_back ? (
          <>
            <a
              href={`/temp_media/intern_aadhar/${internProfile.application_id}/${internProfile.aadhar_front}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: "10px" }}
            >
              Front
            </a>
            <a
              href={`/temp_media/intern_aadhar/${internProfile.application_id}/${internProfile.aadhar_back}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Back
            </a>
          </>
        ) : (
          "-"
        )}
      </p>
      <p>
        <strong>Resume:</strong>{" "}
        {internProfile.application_id && internProfile.resume ? (
          <>
            <a
              href={`/temp_media/intern_resumes/${internProfile.resume}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: "10px" }}
            >
              Resume
            </a>
           
          </>
        ) : (
          "-"
        )}
      </p>



        <p><strong>College:</strong> {internProfile.college}</p>
        <p><strong>Branch:</strong> {internProfile.branch}</p>
        <p><strong>Domain:</strong> {internProfile.domain}</p>
        <p><strong>Duration:</strong> {internProfile.duration}</p>
        <p><strong>Internship Applied Date:</strong> {internProfile.submitted_at}</p>
        <p><strong>Internship Payment Date:</strong> {internProfile.payment_date}</p>
        <p><strong>Transaction ID:</strong> {internProfile.transaction_id}</p>
        <p><strong>Internship Payment Mode:</strong> {internProfile.payment_mode}</p>
        <p><strong>Mode:</strong> {internProfile.mode || "-"}</p>
         <p><strong>Internship Start Date:</strong> {internProfile.internship_start_date}</p>
        <p><strong>Internship End Date:</strong> {internProfile.internship_end_date || "-"}</p>
      </div>

      {/* Right: Profile Image */}
      <div className="profile-image-container">
        <img
          src={internProfile.profile_image ? `/temp_media/intern_profile_images/${internProfile.profile_image}` : "/default-profile.png"}
          alt={internProfile.name}
          className="profile-image"
        />
        {internProfile.completed_status !== undefined && (
        <div
          className={`internship-status ${
            Number(internProfile.completed_status) === 1
              ? "completed"
              : "ongoing"
          }`}
        >
          <strong>Internship Status:</strong>{" "}
          {Number(internProfile.completed_status) === 1
            ? "Completed"
            : "Ongoing"}
        </div>
      )}

      </div>
    </div>
  </div>
)}

{assignedQuestions.length > 0 && (
  <>
  <div className="answers-section">
    <h3>Submitted Assignments</h3>

    <table className="answers-table">
      <thead>
        <tr>
          <th>Assignment ID</th>
          <th>Question</th>
          <th>Total Marks</th>
          <th>Marks Secured</th>
          <th>Status</th>
          <th>Remark</th>
        </tr>
      </thead>
      <tbody>
        {mergedData.map(ans => (
          <tr key={ans.answer_id}>
            <td>{ans.assignment_id}</td>
            <td>{ans.question || "N/A"}</td>
            <td>{ans.total_marks}</td>
            <td>{ans.marks_secured}</td>
            <td
            className={
              ans.status === "corrected"
                ? "approved"
                : ans.status === "pending"
                ? "pending"
                : "not-submitted"
            }
          >
            {ans.status === "corrected"
              ? "Corrected"
              : ans.status === "pending"
              ? "Pending"
              : "Not Submitted"}
          </td>


            <td>{ans.remark}</td>
          </tr>
        ))}

        {/* ---------- TOTAL ROW ---------- */}
        <tr className="total-row">
          <td colSpan={2} style={{ textAlign: "right", fontWeight: "bold" }}>Total:</td>
          <td>
             {mergedData.reduce(
              (sum, ans) => sum + (parseInt(ans.total_marks) || 0),
              0
            )}
          </td>
          <td>
              {mergedData.reduce(
              (sum, ans) => sum + (parseInt(ans.marks_secured) || 0),
              0
            )}
          </td>
          <td colSpan={2}></td>
        </tr>
        <tr className="final-result-row">
          <td colSpan={4} style={{ textAlign: "right", fontWeight: "bold" }}>
            Final Result:
          </td>
          <td
            colSpan={2}
            className={
              overallResult === "Pass"
                ? "pass"
                : overallResult === "Fail"
                ? "fail"
                : ""
            }
            style={{ fontWeight: "bold" }}
          >
            {overallResult}
          </td>
        </tr>

      </tbody>
    </table>
  </div>

    {internProfile?.completed_status === 1 && (
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button
          onClick={() => handleDownloadCertificate(internProfile.application_id)}
          className="cer-button"
        >
          Download Certificate
        </button>
      </div>
    )}
</>
  
)}
</div>

  );
}
